export const SURVEY_ACTIONS = {
    SURVEY_SET_ANSWER: "SURVEY_SET_ANSWER",
    SURVEY_SET_NEXT_QUESTION: "SURVEY_SET_NEXT_QUESTION",
    SURVEY_SET_PREVIOUS_QUESTION: "SURVEY_SET_PREVIOUS_QUESTION",
    SURVEY_CLEAR_DATA: "SURVEY_CLEAR_DATA",
    UPDATE_CURRENT_QUESTION: "UPDATE_CURRENT_QUESTION"
}

export function setSurveyAnswer(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_ANSWER,
        payload: payload
    }
}

export function nextSurveyQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_NEXT_QUESTION,
        payload: payload
    }
}

export function prevSurveyQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.SURVEY_SET_PREVIOUS_QUESTION,
        payload: payload
    }
};

export function clearSurveyData() {
    return {
        type: SURVEY_ACTIONS.SURVEY_CLEAR_DATA
    }
}

export function updateSurveyCurrentQuestion(payload) {
    return {
        type: SURVEY_ACTIONS.UPDATE_CURRENT_QUESTION,
        payload
    }
}
